'use strict';

import angular from 'angular';
import EditController from './edit.controller';

export default angular.module('updateServerApp.screensaver.edit', [])
  .controller('ScreenSaverEditController', EditController)
  .name;



// WEBPACK FOOTER //
// ./client/app/screenSaver/edit/index.js